// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb__header-icon.ActionPending[status=alert][data-v-8c83ba74]{animation:actionPendingBlink-8c83ba74 1s steps(1) infinite}@keyframes actionPendingBlink-8c83ba74{50%{opacity:.2}}", ""]);
// Exports
module.exports = exports;
